import { Injectable } from '@angular/core';

@Injectable()
export class ServidorProvider {
    //45.55.127.165:80
    //192.168.0.17:8080
    //159.65.65.150
    //https://brcomunique.infobrcorp.com.br
    public static readonly URL_SERVIDOR_BRCOMUNIQUE = "https://brcomunique.infobrcorp.com.br"
    public static readonly IP_SERVIDOR_PUSH = "brcomunique.infobrcorp.com.br";
    public static readonly PORTA_SERVIDOR_PUSH = "443";

    public static getIpPortaServidorPush(): string {
        return `${this.IP_SERVIDOR_PUSH }:${this.PORTA_SERVIDOR_PUSH}`;
    }

    public static getUrlChamadaServidor(): string {
        return `${this.URL_SERVIDOR_BRCOMUNIQUE}/api/v1/rest`;
    }

}



// WEBPACK FOOTER //
// ./src/providers/servidor/servidor.ts